import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Grid, 
  Typography, 
  Box, 
  Container,
  Button
} from '@mui/material';
import { PlayCircle } from 'lucide-react';
import ProcessFlow from '../components/ProcessFlow';
import { Header } from '@/components/shared/Header';

const Dashboard = () => {
  const navigate = useNavigate();

  // Navigate to the StartProcess page
  const handleStartProcess = () => {
    navigate('/start-process');
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
       <Header
         title="Keyword Analysis Process Flow"
         subtitle="Visualize the stages of the keyword analysis process."
         btnText="Start Process"
         btnVariant="contained"
         startIcon={<PlayCircle size={20} />}        
        />
      
      <Grid container spacing={3}>
        <ProcessFlow />
      </Grid>
    </Container>
  );
};

export default Dashboard;